import type { CSSProperties } from 'react';
import type { BlockStyle } from '@/blocks/domain/types';
import { BORDER_COLORS } from '@/common/presentation/constants/colors';
import { blockFontFamilyCss, blockFontSizeCss, blockFontWeightCss } from '@/document-render/application/blockFontSize';

/**
 * Maps shared BlockStyle fields to inline CSS for HTML preview renderers.
 * Mirrors blockStyleToPdf semantics for borders, italic, and uppercase.
 */
export function blockStyleToCss(style: BlockStyle, borderColor = BORDER_COLORS.MUTED): CSSProperties {
  return {
    paddingTop: style.paddingY,
    paddingBottom: style.paddingY,
    color: style.textColor,
    background: style.backgroundColor,
    fontSize: blockFontSizeCss(style),
    fontWeight: blockFontWeightCss(style),
    fontFamily: blockFontFamilyCss(style),
    fontStyle: style.italic ? 'italic' : undefined,
    textTransform: style.uppercase ? 'uppercase' : undefined,
    letterSpacing: style.uppercase ? '.06em' : undefined,
    borderTop: style.borderTop ? `1px solid ${style.borderColor || borderColor}` : undefined,
    borderBottom: style.borderBottom ? `1px solid ${style.borderColor || borderColor}` : undefined
  };
}
